import axios from 'axios'
import { apiUrl } from '../config/api'

/**
 * GET /api/stats (public; v2 routers/readonly.py `_measure_stats`).
 *
 * Every number is a Postgres COUNT; a field nothing measures is null.
 *   totalTransactionsProtected  rows in encrypted_transactions
 *   threatsBlocked24h           bridge.mev_events with was_prevented, last 24h
 *   activeUsers                 count(*) FROM users, i.e. REGISTERED users (the
 *                               field name says "active"; label it "Registered")
 *   chains.<name>.protected     encrypted_transactions per chain
 *   chains.<name>.threats       prevented mev_events per chain (all time)
 *   totalValueProtected, averageProtectionLatencyMs  always null
 */
export interface ChainCounts {
  protected: number | null
  threats: number | null
}

export interface PlatformStats {
  status?: string
  dataSource?: string
  totalTransactionsProtected: number | null
  totalValueProtected: number | null
  activeUsers: number | null
  threatsBlocked24h: number | null
  averageProtectionLatencyMs: number | null
  chains?: Record<string, ChainCounts>
  lastUpdated?: string
}

export async function fetchPlatformStats({ signal }: { signal: AbortSignal }): Promise<PlatformStats> {
  try {
    const { data } = await axios.get<PlatformStats>(apiUrl('/api/stats'), { signal })
    return data
  } catch (err) {
    if (axios.isCancel(err)) throw err
    throw new Error('Platform statistics are unavailable right now.')
  }
}
